import { useMutation } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL, IResendConfirmationCodeRequestDto } from '@/dtos';

interface Response {
  destination?: string;
}

interface Payload {
  username: string;
}

const useResendConfirmationCodeQuery = () => {
  const { mutateAsync, isLoading } = useMutation((payload: Payload) =>
    api.post<Response, IResendConfirmationCodeRequestDto>(API_URL.RESEND_CONFIRMATION_CODE, payload)
  );

  return {
    resendSignUpCode: mutateAsync,
    isLoading,
  };
};

export default useResendConfirmationCodeQuery;
